import type { ApiInfo } from '@meego-remote/core/app/common';

export const apiMap: Record<string, ApiInfo> = {
  APIDemandFetchWorkItem: {
    m: 'post',
    u: ['/goapi/v5/workitem/v1/demand_fetch'],
  },
  APIGetRuntimeConfigV2: {
    m: 'post',
    u: ['/goapi/v5/search/general/runtime_config/get/v2'],
  },
  APIGetWorkItemStructureAndDetail: {
    m: 'post',
    u: ['/goapi/v5/search/general/work_item_structure_and_detail/get'],
  },
  APIGetWorkItemTypeInfoV2: {
    m: 'get',
    u: ['/goapi/v2/projects/:project_key/work_item_types'],
    q: ['need_virtual', 'need_manage_permission', 'need_perm_config_permission'],
  },
  APIQueryFlowRole: {
    m: 'post',
    u: ['/goapi/v5/workitem/flowrole/query'],
  },
  APIQueryTemplateBasicInfosByProjectKeyAndWorkItemTypeKey: {
    m: 'get',
    u: ['/goapi/v1/projects/:project_key/templates/basic'],
    q: ['work_item_type', 'skip_shard_project_key', 'permission_filter', 'with_stage_manage'],
  },
  APIGetWorkItemTypeInfoByProjectKeyAndWITypeKey: {
    m: 'get',
    u: ['/goapi/v2/projects/:project_key/work_item_types/:type_key'],
    q: ['skip_shard_project_key', 'current_project_key'],
  },
  APIFindBasicWorkItemByIDV2: {
    m: 'get',
    u: ['/goapi/v2/projects/:project_key/work_item/:work_item_type/:wi_object_id'],
    q: ['read_after_write'],
  },
  APIQueryBusinesses: {
    m: 'get',
    u: ['/goapi/v1/businessline/list/:project_id'],
  },
  APIFetchMinimalInfoWorkItem: {
    m: 'post',
    u: ['/goapi/v5/workitem/v1/minimal_info'],
  },
  APIBatchQueryProjectsBySimpleName: {
    m: 'post',
    u: ['/goapi/v1/project_info/batch/simple_name'],
  },
};
